import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { MessageService } from './message.service';

@Injectable()
export class IntegracaoPagamentoService extends BaseService {

  constructor(private http: HttpClient, private message: MessageService) { super(); }

  criarPedido(valor: number, formaPagamento: 'credit' | 'debit' | 'pix' | 'voucher', parcelas: number,
    nomeCliente: string, nomeCobranca: string
  ) {
    return this.http
      .post(this.UrlService + 'integracaoPagamento/criarPedido', { valor, formaPagamento, parcelas, nomeCliente, nomeCobranca })
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError))
  }
  
  consultarPedido(pedidoCobrancaId: any) {
    return this.http
      .get(this.UrlService + `integracaoPagamento/consultarPedido/${pedidoCobrancaId}`)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError))
  }

  cancelarPedido(orderId: any) {
    return this.http
      .post(this.UrlService + `integracaoPagamento/cancelarPedido/${orderId}`, null)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError))
  }

  fecharPedido(orderId: any) {
    return this.http
      .post(this.UrlService + `integracaoPagamento/fecharPedido/${orderId}`, null)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError))
  }

  listarPedidosStone(page: number) {
    return this.http
      .get(this.UrlService + `integracaoPagamento/listarPedidosStone?page=${page || 1}`)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError))
  }
}
